module.exports = __webpack_public_path__ + "static/media/grid.7e1e2adf.svg";